module.exports = __webpack_public_path__ + "media/43.b0a9c3ad.mp3";